module.exports = __webpack_public_path__ + "14c73534d4047952067ac5cad392001b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/luxenta/Luxenta-SemiBold.ttf
// module id = 1574
// module chunks = 0